/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Styles from './TierGraph.styles';
import TierSvgWrapper from './TierSvgWrapper';
import TierTooltip from './TierTooltip';

const Tier = ({ isActive, isCompleted, tier, tooltipClassName }) => {
  return (
    <div aria-label="partner program tier" css={Styles.tier}>
      <Text fontWeight={700} textAlign="center">
        {tier.label}
      </Text>
      <div
        css={[
          Styles.trophy,
          isActive && Styles.active,
          isCompleted && Styles.completed,
        ]}
      >
        <TierSvgWrapper iconType={{ isActive, isCompleted }} tier={tier.key} />
        {isActive && (
          <div css={Styles.star}>
            <Icon css={Styles.starIcon} name="ratingStarFill" size={20} />
          </div>
        )}
      </div>
      <TierTooltip
        className={tooltipClassName}
        isActive={isActive}
        tier={tier}
      />
    </div>
  );
};

export default Tier;
